module.exports = __webpack_public_path__ + "static/media/PdfIcon.96efdcda.svg";